// import React, { useEffect, useState } from "react";
// import {
//     Card,
//     CardContent,
//     Typography,
//     List,
//     ListItem,
//     Divider,
//     Avatar,
//     Button,
//     Box,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
// import { baseUrl, get } from "../../services/api-services";

// const ProgramsList = () => {
//     const nav = useNavigate();
//     const [programs, setPrograms] = useState([]);
//     const [totalPrograms, setTotalPrograms] = useState(0);
//     const fetchProgramsData = async () => {
//         try {
//             let userCountResponse;
//             const programsResponse = await get(`/Programs?filter={"where":{"status":"active"},"order":"createdAt DESC","limit":"5"}`);
//             if (programsResponse?.statusCode === 200) {
//                 const programIds = programsResponse?.data?.map((program) => program.id);
//                 userCountResponse = await get(`/UserPrograms?filter=${encodeURIComponent(JSON.stringify({ where: { programId: { inq: programIds }, status: "active" }, }))}`);
//             }
//             if (userCountResponse?.statusCode === 200) {
//                 const userPrograms = userCountResponse?.data;
//                 const updatedPrograms = programs.map((program) => {
//                     const matchingUserPrograms = userPrograms.filter(
//                         (userProgram) => userProgram.programId === program.id
//                     );
//                     const totalEnrollments = matchingUserPrograms.length;
//                     return {
//                         ...program,
//                         totalEnrollments,
//                     };
//                 });

//                 setPrograms(updatedPrograms);
//             }
//             const countResponse = await get(`/Programs/count`);
//             if (countResponse?.statusCode === 200) {
//                 setTotalPrograms(countResponse?.data?.count);
//             }
//         } catch (error) {
//             console.error("Error fetching programs:", error);
//         }

//     };

//     useEffect(() => {
//         fetchProgramsData();
//     }, []);

//     const handleClick = () => {
//         nav('/admin/programs');
//     };

//     return (
//         <Card className="flex flex-col flex-1 mt-[20px]">
//             <CardContent className="flex flex-col flex-1 relative">
//                 <Typography variant="h6" gutterBottom>
//                     Programs
//                 </Typography>
//                 <List dense className="flex-1">
//                     {programs?.length > 0 ? (
//                         programs?.map((program) => (
//                             <React.Fragment key={program.id}>
//                                 <ListItem>
//                                     {/* Avatar for program */}
//                                     <Avatar src={`${baseUrl}/Uploads/program/download/${program?.icon}`} alt={program.title} />
//                                     <Box ml={2}>
//                                         <Typography variant="body1">{program.title}</Typography>
//                                         <Typography variant="body2" color="textSecondary">
//                                             {program.totalEnrollments} Enrollments
//                                         </Typography>
//                                     </Box>
//                                     <Box ml="auto">
//                                         <Typography variant="body2" fontWeight={600}>
//                                             ₹{program.totalEnrollments * (program.price || 0)}
//                                         </Typography>
//                                     </Box>
//                                 </ListItem>
//                                 <Divider />
//                             </React.Fragment>
//                         ))
//                     ) : (
//                         <Typography variant="body2" color="textSecondary">
//                             No programs found.
//                         </Typography>
//                     )}
//                 </List>
//                 <Button color="primary"
//                     endIcon={<ChevronRightOutlinedIcon />}
//                     sx={{ textTransform: 'none' }}
//                     className="absolute left-0 bottom-0 max-w-[200px]"
//                     onClick={handleClick}>
//                     {totalPrograms} Total Programs
//                 </Button>
//             </CardContent>
//         </Card>
//     );
// };

// export default ProgramsList;


import React, { useEffect, useState, useCallback } from "react";
import {
    Card,
    CardContent,
    Typography,
    List,
    ListItem,
    Divider,
    Avatar,
    Button,
    Box,
    Skeleton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import { baseUrl, get } from "../../services/api-services";

const ProgramsList = ({ parentLoading }) => {
    const nav = useNavigate();
    const [programs, setPrograms] = useState([]);
    const [totalPrograms, setTotalPrograms] = useState(0);
    const [loading, setLoading] = useState(true);



    const fetchProgramsData = useCallback(async () => {
        setLoading(true);
        try {
            let token = localStorage.getItem("accessToken");
            // Fetch all programs
            const programsResponse = await get(
                `/Programs?filter={"where":{"status":"active"},"order":"createdAt DESC"}`
            );

            if (programsResponse?.statusCode === 200) {
                const programData = programsResponse?.data || [];
                const programIds = programData.map((program) => program.id);

                // Fetch payments instead of UserPrograms to match Sales screen logic
                const paymentsResponse = await get(
                    `/Payments?filter=${encodeURIComponent(
                        JSON.stringify({
                            where: {
                                programId: { inq: programIds }
                            },
                        })
                    )}&access_token=${token}`
                );
                if (paymentsResponse?.statusCode === 200) {
                    const payments = paymentsResponse?.data || [];
                    const updatedPrograms = programData.map((program) => {
                        const matchingPayments = payments.filter(
                            (p) => (p.programId === program.id || p.programId === program._id)
                        );
                        const totalEnrollments = matchingPayments.length;
                        const totalIncome = matchingPayments.reduce((sum, p) => sum + (p.amount || 0), 0);
                        return {
                            ...program,
                            totalEnrollments,
                            totalIncome
                        };
                    });

                    // Limit the programs displayed to 5
                    setPrograms(updatedPrograms.slice(0, 5));
                }
            }

            // Fetch total programs count
            const countResponse = await get(`/Programs/count?access_token=${token}`);
            if (countResponse?.statusCode === 200) {
                setTotalPrograms(countResponse?.data?.count || 0);
            }
        } catch (error) {
            console.error("Error fetching programs:", error);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchProgramsData();
    }, [fetchProgramsData]);

    const handleClick = () => {
        nav("/admin/programs");
    };

    return (
        <Card className="flex flex-col flex-1 mt-[20px]">
            <CardContent className="flex flex-col flex-1">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle1" className=" font-bold">Programs </Typography>
                </Box>
                <List dense className="flex-1">
                    {loading || parentLoading ? (
                        Array.from({ length: 4 }).map((_, i) => (
                            <React.Fragment key={i}>
                                <Box mb={2}>
                                    <ListItem>
                                        <Skeleton variant="circular" width={40} height={40} animation="wave" />
                                        <Box ml={2} sx={{ flex: 1 }}>
                                            <Skeleton variant="text" width="50%" animation="wave" />
                                            <Skeleton variant="text" width="30%" animation="wave" />
                                        </Box>
                                        <Box ml="auto">
                                            <Skeleton variant="text" width={60} animation="wave" />
                                        </Box>
                                    </ListItem>
                                    <Divider />
                                </Box>
                            </React.Fragment>
                        ))
                    ) : programs?.length > 0 ? (
                        programs.map((program) => (
                            <React.Fragment key={program.id} >
                                <Box mb={2}> {/* Adds margin-bottom */}
                                    <ListItem>
                                        {/* Avatar for program */}
                                        <Avatar
                                            src={`${baseUrl}/Uploads/program/download/${program?.icon}`}
                                            alt={program?.title}
                                        />
                                        <Box ml={2}>
                                            <Typography variant="body1">
                                                {program?.title}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {program?.totalEnrollments} Enrollments
                                            </Typography>
                                        </Box>
                                        <Box ml="auto">
                                            <Typography variant="body2" fontWeight={600}>
                                                ₹{program?.totalIncome || 0}
                                            </Typography>
                                        </Box>
                                    </ListItem>
                                    <Divider />
                                </Box>

                            </React.Fragment>
                        ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No programs found.
                        </Typography>
                    )}
                </List>
                <Button
                    color="primary"
                    endIcon={<ChevronRightOutlinedIcon />}
                    sx={{ textTransform: "none" }}
                    className="absolute left-0 bottom-0 max-w-[200px]"
                    onClick={handleClick}
                >
                    {totalPrograms} Total Programs
                </Button>
            </CardContent>
        </Card>
    );
};

export default ProgramsList;





